import { useState } from 'react';
import { Modal } from 'react-bootstrap';

const PRODUCT_ERROR_MAPPINGS = {
  RGRError: 'RGR',
  VATError: 'VAT',
  catchCertError: 'Catch Cert',
  commaError: 'Comma Error',
  commcodeError: 'HS Code',
  descriptionError: 'Description',
  grossMassError: 'Gross Mass',
  healthCertError: 'Health Cert',
  itemValueError: 'Value',
  meursingError: 'Meursing',
  netMassError: 'Net Mass',
  organicError: 'Organic',
  originError: 'Origin',
  packageCountError: 'Packages',
  packagetypeError: 'Package Type',
  preferentialError: 'Pref',
  quantity2Error: 'Qty 2',
  neeNoridconsignorError: 'Consignor',
  invoiceNumberError: 'Invoice number',
};

const OverviewModal = ({ show, onHide, headerErrors, productErrors }) => {
  const [copySuccess, setCopySuccess] = useState(false);

  // Function to copy overview details while retaining formatting
  const handleCopyRichText = () => {
    const textElement = document.getElementById('qaOverviewContent');
    const data = new ClipboardItem({
      ['text/html']: new Blob([textElement.innerHTML], { type: 'text/html' }),
    });
    navigator.clipboard.write([data]);

    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 4000); // Reset after 4 seconds
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header>
        <Modal.Title>Overview</Modal.Title>
        <button type="button" className="btn-close" aria-label="Close" onClick={onHide} />
      </Modal.Header>
      <Modal.Body>
        <div id="qaOverviewContent">
          <p>The following information is required to complete your load:</p>

          {headerErrors?.length > 0 && (
            <>
              <p>
                <strong>Header Fields:</strong>
              </p>
              <ul>
                {headerErrors.map((error) => (
                  <li key={error.field}>{error.name}</li>
                ))}
              </ul>
            </>
          )}

          {productErrors?.length > 0 && (
            <>
              <p>
                <strong>Item Line Fields:</strong>
              </p>
              <ul>
                {productErrors.map((product) => {
                  return Object.keys(product.errorDetails).map((key) => {
                    if (
                      !['error', 'hasError'].includes(key) &&
                      key.toLowerCase().includes('error') &&
                      !!product.errorDetails[key]
                    ) {
                      return (
                        <li key={`${product.errorDetails.itemNumber}-${key}`}>
                          Item {product.errorDetails.itemNumber + 1}: {PRODUCT_ERROR_MAPPINGS?.[key] || 'Unknown'}
                        </li>
                      );
                    }
                  });
                })}
              </ul>
            </>
          )}

          <p>Please provide this information at your earliest convenience.</p>
        </div>

        <div className="d-flex px-2 justify-content-between mt-4">
          <div className="d-flex gap-4 align-items-center">
            <button type="button" className="blue-button-teams" onClick={handleCopyRichText} style={{ width: '12rem' }}>
              Copy to Clipboard
            </button>
            {copySuccess && <div className="text-success">Details copied to clipboard</div>}
          </div>
          <div>
            <button type="button" className="blue-button-teams green-btn" onClick={onHide}>
              Close
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default OverviewModal;
